"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var Button_1 = require("@mui/material/Button");
var Dialog_1 = require("@mui/material/Dialog");
var DialogActions_1 = require("@mui/material/DialogActions");
var DialogContent_1 = require("@mui/material/DialogContent");
var DialogContentText_1 = require("@mui/material/DialogContentText");
var DialogTitle_1 = require("@mui/material/DialogTitle");
var Confirmation = /** @class */ (function (_super) {
    __extends(Confirmation, _super);
    function Confirmation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.doConfirmation = function () {
            _this.props.confirm();
            _this.props.hide();
        };
        return _this;
    }
    Confirmation.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(Dialog_1.default, { open: this.props.show, onClose: this.props.hide, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", children: [(0, jsx_runtime_1.jsx)(DialogTitle_1.default, { id: "alert-dialog-title", children: this.props.title }), (0, jsx_runtime_1.jsx)(DialogContent_1.default, { children: this.props.children || ((0, jsx_runtime_1.jsx)(DialogContentText_1.default, { id: "alert-dialog-description", children: this.props.message })) }), (0, jsx_runtime_1.jsxs)(DialogActions_1.default, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, { onClick: this.doConfirmation, color: "primary", children: this.props.confirmBtnText || 'Confirm' }), (0, jsx_runtime_1.jsx)(Button_1.default, { onClick: this.props.hide, color: "primary", children: "Cancel" })] })] }));
    };
    Confirmation = __decorate([
        components_1.authorize
    ], Confirmation);
    return Confirmation;
}(React.Component));
exports.default = Confirmation;
//# sourceMappingURL=Confirmation.js.map